<script setup>
defineOptions({
  inheritAttrs: true,
})
defineProps(['control-id'])
</script>
<template>
  <div class="schema-field-layout form-check">
    <slot name="control" />
    <label class="form-check-label" :for="controlId">
      <slot name="label" />
    </label>
  </div>
</template>
